import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { IGetMessage, IUser } from '@core/models';
import { Contact } from '@core/services';
import { TranslateModule } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-buzon-modal',
  imports: [MatDialogModule, TranslateModule, DatePipe],
  templateUrl: './buzon-modal.html',
  styleUrl: './buzon-modal.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuzonModal implements OnInit {
  public readonly dialogRef = inject(MatDialogRef<BuzonModal>);
  public readonly data: { user: IUser } = inject(MAT_DIALOG_DATA);
  private readonly contact = inject(Contact);

  /** Variable que guardará la lista de mensajes*/
  protected readonly buzon = signal<IGetMessage[]>([]);
  /** variable que guardará la descripción del mensaje*/
  protected readonly body = signal<string>('');
  /** variable que guardará la fecha*/
  protected readonly fecha = signal<string>('');
  /** variable que guarda el asunto PQRD*/
  protected readonly pqrd = signal<string>('');

  constructor() {}

  /**
   * Función nativa de angular, esta se activa después del constructor, aqui se llama al método
   * getBuzon(), esto con el fin de mostrarlos en la pantalla principal del buzón de mensajes.
   */
  ngOnInit() {
    this.getBuzon();
  }

  /**
   * Función asincrona que obtinene los mensajes que aparecerán en el buzón de mensajes del usurio,
   * para esto hace uso del ContactService.
   */
  private async getBuzon() {
    try {
      const response = await lastValueFrom(this.contact.getQuestion(String(this.data.user.id)));
      // console.log('Buzon', preguntas);
      this.buzon.set(response || []);
    } catch (error) {
      console.error('Error al obtener el buzón:', error);
    }
  }

  /**
   * Función que inicializa las variables body, fecha y pqrd con los datos que llegan por parametros,
   * @param body Parametro que recibirá la descripción
   * @param fecha parametro que recibirá la fecha de creaciond el mensaje
   * @param pqrd Parametro que recibirá el asunto del mensaje.
   */
  protected cuerpo(body: string, fecha: string, pqrd: string) {
    this.body.set(body);
    this.fecha.set(fecha);
    this.pqrd.set(pqrd);
  }
}
